import { createContext, useCallback, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { selectHasInfluencerSubscription } from '../../../Redux/userSlice';

const InfluencerCheckoutContext = createContext(null);

export const SUBSCRIPTION_STATUS = {
  IDLE: 'idle',
  PROCESSING: 'processing',
  TIMEOUT: 'timeout',
};

export const InfluencerCheckoutProvider = ({ children }) => {
  const hasActiveSubscription = useSelector(selectHasInfluencerSubscription);
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState(SUBSCRIPTION_STATUS.IDLE);

  const openCheckout = useCallback(
    (nextPlan) => {
      if (hasActiveSubscription) {
        toast.info('You already have an active Insta Tools subscription.');
        return;
      }
      setPlan(nextPlan);
      setOpen(true);
      setSubscriptionStatus(SUBSCRIPTION_STATUS.IDLE);
    },
    [hasActiveSubscription]
  );

  const closeCheckout = useCallback(() => {
    setOpen(false);
    setSubscriptionStatus(SUBSCRIPTION_STATUS.IDLE);
  }, []);

  return (
    <InfluencerCheckoutContext.Provider
      value={{
        open,
        plan,
        openCheckout,
        closeCheckout,
        subscriptionStatus,
        setSubscriptionStatus,
      }}
    >
      {children}
    </InfluencerCheckoutContext.Provider>
  );
};

export const useInfluencerCheckout = () => useContext(InfluencerCheckoutContext);
